import React from "react";
import styles from "./Categories.module.css";
import { FaLightbulb, FaCogs } from "react-icons/fa";

const Categories = () => {
  const categories = [
    {
      title: "IRL Open Category",
      description: (
        <>
          <span className={styles.highlight}>A project-based</span> competition
          where students create their own innovative intelligent
          robotics/electronics solution or software-based coding relating to the
          SDG theme.
          <br /> There is{" "}
          <span className={styles.highlight}>no restriction</span> on the use of
          materials, including free choice of{" "}
          <span className={styles.highlight}>
            controllers, motors, sensors, etc.
          </span>
          <br />
          Teams will present their project and their robot model to a group of
          judges on the competition day.{" "}
          <span className={styles.highlight}>
            Awards are eligible for open category as regular category.
          </span>
        </>
      ),
      icon: <FaLightbulb />,
    },
    {
      title: "IRL Regular Category",
      description: (
        <>
          <span className={styles.highlight}>A challenge-based</span>{" "}
          competition where students must design, construct, and program an
          autonomous robot that can solve specific challenges on a field.
          <br />
          Because the field is set up randomly each round, the robot{" "}
          <span className={styles.highlight}>
            needs to be able to make its own decisions during the run.
          </span>
          <br /> All parts of the robot, including{" "}
          <span className={styles.highlight}>
            controller, motors, and sensors
          </span>{" "}
          must be from{" "}
          <span className={styles.highlight}>
            STEMx Robotics (Only Designed for IRL)
          </span>
          .
        </>
      ),
      icon: <FaCogs />,
    },
  ];

  return (
    <section className={styles.categories}>
      <h2 data-aos="fade-up">
        Explore Our <span className={styles.highlight}>Categories</span>
      </h2>
      <div className={styles.categoriesGrid}>
        {categories.map((category, index) => (
          <div key={index} className={styles.categoryCard}>
            <div className={styles.categoryIcon}>{category.icon}</div>
            <h3>{category.title}</h3>
            <p>{category.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Categories;
